import { render } from "./SurveyPlus.vue?vue&type=template&id=730408e7&ts=true"
import script from "./SurveyPlus.vue?vue&type=script&lang=ts"
export * from "./SurveyPlus.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__